import router from "./router";

router.beforeEach(async (to, from, next) => {
  const hasToken = localStorage.getItem("token");

  if (to.path === "/") {
    //判断是否进入的login页
    if (hasToken) {
      //判断是否登陆
      console.log("登录了111");
      next({ path: "/home" }); //登录了
    } else {
      console.log("登录了222");
      next(); //没登录，继续进入login页
    }
  } else {
    //如果进入的非login页
    if (hasToken) {
      //同样判断是否登陆
      console.log("登录了333");
      next();
    } else {
      console.log("登录了444");
      // next(); //没登录，跳转到login页
      next();
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
});



// WEBPACK FOOTER //
// ./src/permission.js